export const ROLES = {
  SUPER: ["Admin", "NetworkOwner"],
  ORG_ADMIN: ["Admin", "NetworkOwner", "CompanyAdmin"],
  OPS: ["Admin", "NetworkOwner", "CompanyAdmin", "Manager"],
  READ: ["Admin", "NetworkOwner", "CompanyAdmin", "Manager", "Auditor"],
};

export const currentRole = () => {
  try {
    return JSON.parse(localStorage.getItem("adminUser") || "null")?.role || "";
  } catch {
    return "";
  }
};

export const canAccessSettings = (role = currentRole()) =>
  ROLES.ORG_ADMIN.includes(role);
export const canAccessIntegrations = (role = currentRole()) =>
  ROLES.ORG_ADMIN.includes(role);
export const canManageUsers = (role = currentRole()) =>
  ROLES.ORG_ADMIN.includes(role);
export const canManageOrganizations = (role = currentRole()) =>
  ROLES.ORG_ADMIN.includes(role);
export const isSuperAdmin = (role = currentRole()) => ROLES.SUPER.includes(role);
export const canWriteAssets = (role = currentRole()) => ROLES.OPS.includes(role);
export const isAuditor = (role = currentRole()) => role === "Auditor";
export const isManager = (role = currentRole()) => role === "Manager";
export const isEmployee = (role = currentRole()) => role === "Employee";
